import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initializeTheme } from "./hooks/useTheme";
import "./theme.css";
import "./styles/theme.css";
import App from "./App.jsx";

// Metadata de build (E4-FE.4) — disponível tecnicamente via console,
// sem UI/endpoint novo.
window.__APP_VERSION__ = { git_sha: import.meta.env.VITE_GIT_SHA || "unknown" };

// Inicializa o tema antes do React montar (evita flash de cor errada)
initializeTheme();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
